export const asyncSetState = async (scope, payload = null) => await new Promise(r => scope.setState(payload, r))
